"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Typography_1 = __importDefault(require("../../Typography"));
var DialogTitleMobile = function (props) {
    var children = props.children, onClose = props.onClose;
    return (react_1.default.createElement(AppBar_1.default, { position: "relative" },
        react_1.default.createElement(Toolbar_1.default, null,
            react_1.default.createElement(Grid_1.default, { container: true, spacing: 1, alignItems: "center" },
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(Close_1.default, { fontSize: "small", onClick: onClose })),
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(Typography_1.default, null, children))))));
};
exports.default = DialogTitleMobile;
